
export enum VideoCoachingStatus {
    None,
    DriverTrained,
    Praise
}
